import React from 'react';
import Icon from "../Icon";

import "./InfoIcon.scss";

type InfoIconProps = {
  // The ID of the element which contains the tooltip content.
  tooltip: string;
}

export class InfoIcon extends React.Component<InfoIconProps> {

  render() {
    return <Icon icon="info" size="xs" className="InfoIcon" data-tip data-for={this.props.tooltip}/>
  }
}
